import React, { useEffect, useState } from 'react';
import s from './PromptBlock.module.css';
import Templates from '../../../../shared/ui/templates/Templates';
import { useSelector } from 'react-redux';
import { selectCurrentProject } from '../../../../store/selectors/projectSelectors';
import { Template } from '../../../../store/slices/templatesSlice';
import { useAppDispatch } from '../../../../store/store';
import IconGeneral from '../../../../shared/ui/icons/IconGeneral';
import IconNews from '../../../../shared/ui/icons/IconNews';
import IconProductPromotion from '../../../../shared/ui/icons/IconProductPromotion';
import IconEvents from '../../../../shared/ui/icons/IconEvents';
import IconEducational from '../../../../shared/ui/icons/IconEducational';
import IconAd from '../../../../shared/ui/icons/IconAd';
import IconPoll from '../../../../shared/ui/icons/IconPoll';
import IconDiscussion from '../../../../shared/ui/icons/IconDiscussion';
import IconContest from '../../../../shared/ui/icons/IconContest';
import { generateContent, updateProject } from '../../../../shared/api/textProjectApi';
import { toast } from 'react-toastify';
const TemplatesBlock = () => {
    const dispatch = useAppDispatch();

    const currentProject = useSelector(selectCurrentProject);

    const initialTemplate = currentProject?.content_type
        ? { tag: currentProject.content_type }
        : null;
    const [selectedTemplate, setSelectedTemplate] = useState<Template | null>(initialTemplate);

    const typeOfPost = [
        { tag: 'general', text: 'General', icon: <IconGeneral /> },
        { tag: 'news', text: 'News', icon: <IconNews /> },
        { tag: 'product', text: 'Product promotion', icon: <IconProductPromotion /> },
        { tag: 'events', text: 'Events', icon: <IconEvents /> },
        { tag: 'educational', text: 'Educational', icon: <IconEducational /> },
        { tag: 'ad', text: 'Ad', icon: <IconAd /> },
        { tag: 'poll', text: 'Poll', icon: <IconPoll /> },
        { tag: 'discussion', text: 'Discussion', icon: <IconDiscussion /> },
        { tag: 'contest', text: 'Contest', icon: <IconContest /> },
    ];

    const initialPostType = currentProject?.post_type || 'general';

    const updateTemplate = async (selectedTemplated: Template) => {
        setSelectedTemplate(selectedTemplated);
        await dispatch(updateProject({ ...currentProject, content_type: selectedTemplated.tag }));
        await handleGenerateScript();
    };
    const updatePostType = async (selectedPostType: string) => {
        await dispatch(updateProject({ ...currentProject, post_type: selectedPostType }));
        await handleGenerateScript();
    };
    const handleGenerateScript = async () => {
        if (currentProject?.id) {
            try {
                const response = await dispatch(
                    generateContent({ projectId: currentProject.id, kind: 'text_only' }),
                ).unwrap();
                console.log('Script generated successfully:', response);
            } catch (error: any) {
                toast.error(error?.message || 'Failed to handle generate script');
                console.error('Failed to handle generate script:', error);
            }
        }
    };

    return (
        <div className={s.container}>
            <div className={s.block_container}>
                <p className={s.header}>Choose one of the following channels</p>
                <Templates
                    currentTemplate={selectedTemplate}
                    handleTemplateSelection={updateTemplate}
                    sizeContainer="small"
                />
            </div>
            <div className={s.block_container}>
                <p className={s.header}>Pick the type of the post</p>
                <div className={s.type_of_post_container}>
                    {typeOfPost.map((item) => (
                        <div
                            key={item.tag}
                            className={`${s.type_of_post_item} ${initialPostType === item.tag ? s.active : ''}`}
                            onClick={() => updatePostType(item.tag)}
                        >
                            <div className={s.type_of_post_icon}>{item.icon}</div>
                            <div className={s.type_of_post_text}>{item.text}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TemplatesBlock;
